import styled from '@emotion/styled';
import { mediaQuery, responsiveFontSize } from '@presentation/styles';

export const BornContainer = styled.div`
  width: 100%;
  display: flex;
  overflow: hidden;
  box-shadow: 0 0 14px 0 rgba(0, 0, 0, 0.15);
  ${mediaQuery('tablet')} {
    flex-direction: column;
    min-height: auto;
  }
`;

export const BornWrapper = styled.div<{ blueVariant: 'light' | 'lightBlue' | 'default' }>`
  width: 50%;
  padding: 10%;
  ${mediaQuery('tablet')} {
    width: 100%;
    padding: 50px;
  }
  background: ${(props) => props.theme.color.blue[props.blueVariant]};
  color: ${(props) =>
    props.blueVariant === 'default'
      ? props.theme.color.light.default
      : props.theme.color.blue.default};
  display: flex;
  flex-direction: column;
  & > *:not(:last-child) {
    margin-bottom: 20px;
  }
  align-items: center;
  justify-content: center;
  position: relative;
  cursor: pointer;
  :hover {
    ::after {
      content: '';
      position: absolute;
      background: ${(props) =>
        props.blueVariant === 'light' ? 'rgba(255, 255, 255, 0.4)' : 'rgba(255, 255, 255, 0.2)'};
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      z-index: 1;
    }
  }
`;

export const BornTitle = styled.div`
  text-align: center;
  ${responsiveFontSize(26, 2)}
  font-family: ${(props) => props.theme.font.alternate};
  font-weight: 600;
`;

export const BornImage = styled.img`
  height: 150px;
  width: 200px;
  object-fit: contain;
  object-position: bottom;
`;

export const Wrapper = styled.div`
  margin: 30px auto;
  padding-left: 30px;
  padding-right: 30px;
  width: min-content;
`;

export const Container = styled.div`
  position: relative;
  border-radius: 15px;
  background: ${(props) => props.theme.color.light.default};
  box-shadow: 0 0 14px 0 rgba(0, 0, 0, 0.15);
`;

export const ImageContainer = styled.div`
  margin: -10px;
  margin-bottom: 30px;
  display: flex;
  flex-wrap: wrap;
`;

export const ImageWrapper = styled.div<{ imagesAmount: number }>`
  ${(props) => {
    if (props.imagesAmount <= 6) {
      return { width: '33%', height: '180px' };
    }

    if (props.imagesAmount > 6 && props.imagesAmount <= 12) {
      return { width: '25%', height: '120px' };
    }

    return { width: '20%', height: '80px' };
  }};

  padding: 10px;
  padding-bottom: 10px;

  ${mediaQuery('phone')} {
    width: 50%;
  }
`;

export const ParentImageWrapper = styled.div`
  height: 200px;
  padding-bottom: 10px;
`;

export const ParentInputWrapper = styled.div`
  display: inline-flex;
  & > *:not(:last-child) {
    margin-right: 5px;
  }
  align-items: flex-start;
  justify-content: space-between;
`;

export const ParentAddButton = styled.a<{ disabled: boolean }>`
  flex-basis: 40px;
  flex-shrink: 0;
  height: 40px;
  width: 40px;
  border-radius: 10px;

  display: inline-flex;
  justify-content: center;
  align-items: center;

  cursor: pointer;
  font-weight: 600;
  font-size: 16px;

  border: 2px solid ${(props) => props.theme.color.blue.default};
  color: ${(props) => props.theme.color.blue.default};
  background: ${(props) => props.theme.color.blue.glass};

  ${(props) =>
    props.disabled &&
    `
      cursor: not-allowed;
      border: 2px solid ${props.theme.color.light.shade};
      color: ${props.theme.color.medium.default};
      background: ${props.theme.color.light.shadeLighter};
  `}
`;
export const ErrorText = styled.div`
  margin-top: 5px;
  margin-bottom: 5px;
  font-size: 12px;
  font-weight: 600;
  color: ${(props) => props.theme.color.red.default};
  text-align: left;
`;
